import { http } from '.';

export const getWeixinAccessToken = async () => {
  const response = await http.get(`/weixin/getAccessToken`);
  return response;
};
export const getWeixindDecryptData = async () => {
  const response = await http.get(`/weixin/decryptData`);
  return response;
};
export const postWeixinSignToken = async (
  payload: any
) => {
  // {
  //   "accessToken": "string",
  //   "nonceStr": "string",
  //   "timestamp": "string",
  //   "url": "string"
  // }
  const response = await http.post(`/weixin/signAccessToken` , payload);
  return response;
};

export const postWeixinOpenId = async (
  payload: any
) => {
  // {
  //   "accessToken": "string",
  //   "nonceStr": "string",
  //   "timestamp": "string",
  //   "url": "string"
  // }
  // /v1/kaddie/weixin/jscode2session
  const response = await http.post(`/weixin/jscode2session` , payload);
  return response;
};